import { global } from ":shared/app";

const endpoint = "/account/update/participant/attendance/";
export type POST = {
  props: {
    email: string;
    fullname_ar: string;
    fullname_en: string;
    file: FileList;
  };
};
export function post(props: POST["props"]) {
  const data = props;
  const formData = new FormData();
  formData.set("email", data.email);
  formData.set("fullname_ar", data.fullname_ar);
  formData.set("fullname_en", data.fullname_en);
  formData.set("is_accept_attendance", String(true));
  formData.set("attendance_files", data.file.item(0));
  return global.api.post(endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
